document.addEventListener('DOMContentLoaded', function () {
  const stickyBarElement = document.getElementById('sticky-bar');
  if (stickyBarElement) document.body.appendChild(stickyBarElement);

  const stickyBar = document.getElementById('sticky-bar');
  const stickyImage = document.getElementById('sticky-variant-image');
  const stickyPrice = document.getElementById('sticky-price');
  const stickyMsrp = document.getElementById('sticky-msrp');
  const stickySavings = document.getElementById('sticky-savings');
  const stickyVariantIdInput = document.getElementById('sticky-variant-id');
  const variantImageMap = document.getElementById('variant-image-map');
  const stickyAddons = document.getElementById('sticky-addons');
  const continueBtnForm = stickyBar.querySelector('form.continue-btn');

  const productJson = document.querySelector('[type="application/json"][data-product-json]');
  if (!productJson) return;
  const variantData = JSON.parse(productJson.textContent);
  const variants = variantData.variants;
  const variantInput = document.querySelector('input[name="id"]');

  function formatCurrency(valCents) {
    const hostname = window.location.hostname;

    let currency = "USD"; // Default
    if (hostname.includes("lorex.ca")) {
      currency = "CAD";
    } else if (hostname.includes("lorex.com")) {
      currency = "USD";
    } else if (hostname.includes("lorextechnology.co.uk")) {
      currency = "GBP";
    }

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valCents / 100);
  }


  function updateStickyBar(variantId) {
    const variant = variants.find(v => v.id === parseInt(variantId));
    if (!variant) return;
    stickyBar.classList.remove('hidden');

    const imageDiv = variantImageMap?.querySelector(`[data-variant-id="${variantId}"]`);
    if (imageDiv && stickyImage) {
      stickyImage.src = imageDiv.getAttribute('data-img-url');
      stickyImage.alt = variant.featured_image?.alt || '';
    }

    const variantPrice = variant.price;
    const variantCompareAt = variant.compare_at_price || 0;

    let addonsPrice = 0;
    let addonsCompareAt = 0;

    document.querySelectorAll('.addon-checkbox:checked').forEach(checkbox => {
      const parent = checkbox.closest('.addons-item');
      const quantity = parseInt(parent.querySelector('.addon-quantity')?.value || 1);
      const rawPrice = (parent.querySelector('.addons-item-price')?.textContent || "").replace(/[^0-9.]/g, "");
      const rawCompare = (parent.querySelector('.addons-regular-price b')?.textContent || "").replace(/[^0-9.]/g, "");
      const price = Math.round(Number(rawPrice) * 100) || 0;
      const compare = Math.round(Number(rawCompare) * 100) || 0;
      addonsPrice += price * quantity;
      addonsCompareAt += compare * quantity;
    });

    const totalPrice = variantPrice + addonsPrice;
    const totalCompareAt = variantCompareAt + addonsCompareAt;
    const savings = Math.max(0, totalCompareAt - totalPrice);

    stickyPrice.textContent = formatCurrency(totalPrice);
    stickyVariantIdInput.value = variantId;

    if (totalCompareAt > totalPrice) {
      stickyMsrp.textContent = formatCurrency(totalCompareAt);
      stickyMsrp.classList.remove('hidden');
      stickySavings.textContent = `Save ${formatCurrency(savings)}`;
    } else {
      stickyMsrp.textContent = '';
      stickyMsrp.classList.add('hidden');
      stickySavings.textContent = '';
    }
  }

  function updateStickyAddons() {
    if (!stickyAddons) return;
    stickyAddons.innerHTML = '';

    document.querySelectorAll('.addon-checkbox:checked').forEach(checkbox => {
      const parent = checkbox.closest('.addons-item');
      const img = parent.querySelector('img');
      const quantity = parent.querySelector('.addon-quantity')?.value || 1;

      if (img) {
        const wrapper = document.createElement('div');
        wrapper.className = 'flex items-center gap-1 bundle-wrapper-item';
        const clone = img.cloneNode(true);
        clone.className = 'w-10 h-auto object-cover';
        const qty = document.createElement('span');
        qty.className = 'addon-qty';
        qty.textContent = `x${quantity}`;
        wrapper.appendChild(clone);
        wrapper.appendChild(qty);
        stickyAddons.appendChild(wrapper);
      }
    });

    if (variantInput?.value) updateStickyBar(variantInput.value);
  }

  function updateStickyFormSubmission() {
    if (!continueBtnForm) return;

    continueBtnForm.onsubmit = function (e) {
      e.preventDefault();

      const variantId = stickyVariantIdInput?.value;
      if (!variantId) return;

      const items = [];
      const bundlerProperty = document.querySelector('.bundlerproperties')?.value || '';

      items.push({
        id: parseInt(variantId),
        quantity: 1,
        properties: { '_mbb': bundlerProperty }
      });

      document.querySelectorAll('.addon-checkbox:checked').forEach(checkbox => {
        const parent = checkbox.closest('.addons-item');
        const id = parent.querySelector('.form-id')?.value;
        const quantity = parseInt(parent.querySelector('.addon-quantity')?.value || 1);
        const prop = parent.querySelector('.bundlerproperties')?.value || '';

        if (id) {
          items.push({
            id: parseInt(id),
            quantity,
            properties: { '_mbb-addon': prop }
          });
        }
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      }).then(res => {
        if (res.ok) {
          window.location.href = '/cart?storefront=true';
        } else {
          alert('Failed to add items to cart. Please try again.');
        }
      }).catch(err => {
        console.error('Add to cart error:', err);
        alert('There was an error. Please try again.');
      });
    };
  }

  function enableAddonCheckboxLogic() {
    document.querySelectorAll('.addon-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        const parent = checkbox.closest('.addons-item');
        const quantityControls = parent.querySelector('.quantity-controls');
        const input = parent.querySelector('.addon-quantity');
        const minus = parent.querySelector('.quantity-minus');
        const plus = parent.querySelector('.quantity-plus');
        const price = parent.querySelector('.addons-item-price');
        const regular = parent.querySelector('.addons-regular-price');

        if (checkbox.checked) {
          quantityControls?.classList.remove('hidden');
          input?.removeAttribute('disabled');
          minus?.removeAttribute('disabled');
          plus?.removeAttribute('disabled');
          price?.classList.remove('hidden');
          regular?.classList.add('hidden');
        } else {
          quantityControls?.classList.add('hidden');
          input?.setAttribute('disabled', 'true');
          minus?.setAttribute('disabled', 'true');
          plus?.setAttribute('disabled', 'true');
          input.value = 1;
          price?.classList.add('hidden');
          regular?.classList.remove('hidden');
        }

        updateStickyAddons();
        updateStickyFormSubmission();
      });
    });

    document.querySelectorAll('.addon-quantity').forEach(input => {
      input.addEventListener('input', () => {
        const val = parseInt(input.value);
        if (isNaN(val) || val < 1) input.value = 1;
        updateStickyAddons();
        updateStickyFormSubmission();
      });
    });
  }

  function enableQuantityButtons() {
    document.querySelectorAll('.quantity-plus').forEach(button => {
      button.addEventListener('click', () => {
        const input = button.closest('.addons-item')?.querySelector('.addon-quantity');
        if (!input?.disabled) {
          input.value = parseInt(input.value || 1) + 1;
          input.dispatchEvent(new Event('input'));
        }
      });
    });

    document.querySelectorAll('.quantity-minus').forEach(button => {
      button.addEventListener('click', () => {
        const input = button.closest('.addons-item')?.querySelector('.addon-quantity');
        const val = parseInt(input.value || 1);
        if (!input?.disabled && val > 1) {
          input.value = val - 1;
          input.dispatchEvent(new Event('input'));
        }
      });
    });
  }

  function initFilters() {
    const cardSections = document.querySelectorAll(".card__section");
    cardSections.forEach((section) => {
      const filtersContainer = section.querySelector(".filters");
      const addonsContainer = section.querySelector(".addons-container");
      if (!filtersContainer || !addonsContainer) return;

      const productTypes = Array.from(new Set(
        Array.from(addonsContainer.querySelectorAll(".addons-item"))
          .map(el => el.dataset.productType)
          .filter(Boolean)
      ));

      filtersContainer.innerHTML = '';
      productTypes.forEach((type, j) => {
        const label = document.createElement('label');
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.className = 'filter-checkbox';
        checkbox.value = type;
        if (j === 0) checkbox.checked = true;
        label.appendChild(checkbox);
        label.appendChild(document.createTextNode(" " + type));
        filtersContainer.appendChild(label);
        filtersContainer.appendChild(document.createElement('br'));
      });

      filtersContainer.addEventListener('change', () => {
        const checked = Array.from(filtersContainer.querySelectorAll(".filter-checkbox:checked")).map(c => c.value);
        Array.from(addonsContainer.querySelectorAll(".addons-item")).forEach(item => {
          item.style.display = checked.length === 0 || checked.includes(item.dataset.productType) ? '' : 'none';
        });
      });
    });
  }

  function waitForFilterBlocks(callback, timeout = 5000) {
    const start = Date.now();
    function check() {
      const allReady = Array.from(document.querySelectorAll('.card__section')).every(section =>
        section.querySelector('.filters') &&
        section.querySelector('.addons-container') &&
        section.querySelector('.addons-item')
      );

      if (allReady) {
        callback();
        enableAddonCheckboxLogic();
        enableQuantityButtons();
        updateStickyFormSubmission();
        if (variantInput?.value) updateStickyBar(variantInput.value);
      } else if (Date.now() - start < timeout) {
        setTimeout(check, 100);
      } else {
        console.warn("⚠️ Timeout: Filters not initialized");
      }
    }

    check();
  }

  if (variantInput) {
    const observer = new MutationObserver(() => {
      if (variantInput.value) updateStickyBar(variantInput.value);
    });
    observer.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    updateStickyBar(variantInput.value);
  }

  waitForFilterBlocks(initFilters);
});
